import * as OFMSUI from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Field, useFormik, FormikProvider, ErrorMessage } from "formik";
import * as Yup from "yup";
import React, { useRef, useState } from "react";
import { Form } from "react-bootstrap";
import HousingService from "../../../Services/HousingService";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { LabelHeader, ModuleHeader, SubmitButton, } from "../../utils/commonFunctions";
import { store } from "../../../App";
import ShowAlert from "../../alert";
import { Table } from "react-bootstrap";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { useReactToPrint } from "react-to-print";


const BankRenconciliationStatement = () => {
    const [bankNamesList, setbankNamesList] = useState([]);
    const [monthlist, setmonthlist] = useState([]);
    const [yearlist, setyearlist] = useState([]);
    const [brsReconciliationData, setbrsReconciliationData] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [saveMonth, setSaveMonth] = useState([]);
    const [month, setMonth] = useState("");
    const [date, setDate] = useState("");
    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,

        documentTitle: "Bank Renconciliation Statement",
    });



    const validationSchema = Yup.object().shape({
        bankname: Yup.string().required("required"),
        year: Yup.string().required("required"),
        month: Yup.string().required("required"),

    });
    const formik = useFormik({
        initialValues: {
            bankname: "",
            year: "",
            month: "",
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            let monthname = saveMonth
                .filter((item) => item.month_id === formik.values.month)
                .map((item) => item.month_name);
            setMonth(monthname);


            const getLastDateOfMonth = (month, year) => {
                const lastDay = new Date(year, month, 0).getDate();
                const formattedMonth = String(month).padStart(2, '0');
                return `${lastDay}-${formattedMonth}-${year}`;
            };

            const finalDate = getLastDateOfMonth(values.month, values.year);
            setDate(finalDate);

            let params = {
                brsBanknameaccountno: values.bankname,
                brsYear: values.year,
                brsMonth: values.month,
            };

            store.dispatch({ type: "SHOW_SPINNER" });
            HousingService.BankReconciliationStatement(params)
                .then((res) => {
                    console.log(res.data);
                    setbrsReconciliationData(res.data[0]);
                })
                .catch((error) => {
                    ShowAlert("Some error occurred", "error");
                    console.log(error);
                })
                .finally(() => {
                    store.dispatch({ type: "HIDE_SPINNER" });
                    setShowTable(true);
                });
        }

    });

    React.useEffect(() => {
        HousingService.fetchMonthList().then((res) => { if (res.data) { setSaveMonth(res.data); let options = res.data.map((item, i) => { return (<option key={i} value={item.month_id}> {item.month_name} </option>); }); setmonthlist(options); } });

        HousingService.fetchYearList().then((res) => { if (res.data) { let options = res.data.map((item, i) => { return (<option key={i} value={item.year}> {item.year} </option>); }); setyearlist(options); } });

        HousingService.fetchBank().then((res) => {
            if (res.data) {
                let options = res.data.map((item, i) => {
                    if (item !== null) {
                        return (
                            <option key={i} value={item.banknameaccountno}> {item.banknameaccountno} </option>
                        );
                    }
                });
                setbankNamesList(options);
            }
        });
    }, []);


    return (
        <>
            <NavigationServicesHeader />
            <ModuleHeader title="Bank Reconciliation Statement" />

            <div ref={componentRef}>
                <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
                    <FormikProvider value={formik}>
                        <Form onSubmit={formik.handleSubmit}>
                            
                            <OFMSUI.Row className="mb-3">
                                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > <LabelHeader title="Month" /> <Field component="select" name="month" className={formik.touched.month && formik.errors.month ? "form-control is-invalid" : "form-control"} > <option value="">Select</option> {monthlist} </Field><ErrorMessage name="month" component={"div"} className="text-error" /> </OFMSUI.Col>
                                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > <LabelHeader title="Year" /> <Field component="select" name="year" className={formik.touched.year && formik.errors.year ? "form-control is-invalid" : "form-control"} > <option value="">Select</option> {yearlist} </Field> <ErrorMessage name="year" component={"div"} className="text-error" /></OFMSUI.Col>
                                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > <LabelHeader title="Bank" /> <Field component="select" name="bankname" className={formik.touched.bankname && formik.errors.bankname ? "form-control is-invalid" : "form-control"} > <option value="">Select</option> {bankNamesList} </Field> <ErrorMessage name="bankname" component={"div"} className="text-error" /> </OFMSUI.Col>
                            </OFMSUI.Row>
                            <SubmitButton title="Submit" />
                            {showTable && (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '50vh', padding: '20px', }} >
                                    <div style={{ overflow: 'auto', height: '550px', width: '100%', maxWidth: '1000px', }} >
                                        <Table striped bordered hover id='my-table' style={{ width: '100%', textAlign: 'center' }} >
                                            <thead className='fw-bold' style={{ top: '0px', position: 'sticky' }}> <tr className='table_countshead' style={{ textAlign: 'center' }}> <th colSpan={4}> BRS for the month of {month} as on {date} </th> </tr>
                                            </thead>
                                            <tbody>
                                                {/* Corporation Book Balance */}
                                                <tr style={{ textAlign: 'left' }}> <td>1</td> <td colSpan={2} style={{ textAlign: 'center' }}> <b>Bank Balance As per Corporation Books</b> </td> <td>{brsReconciliationData?.balance}</td> </tr>
                                                {/* ADD Section */}
                                                <tr style={{ textAlign: 'left' }}> <td></td> <td colSpan={3}> <b>ADD</b> </td> </tr>
                                                <tr style={{ textAlign: 'left' }}> <td></td> <td>(a) Cheque Issued But Not Presented In Bank</td> <td>{brsReconciliationData?.paymentamount}</td> <td></td> </tr>
                                                <tr style={{ textAlign: 'left' }}> <td></td> <td>(b) Direct Credit</td> <td>{brsReconciliationData?.directcredit}</td> <td></td> </tr>
                                                <tr style={{ textAlign: 'left' }}> <td></td> <td>(c) Outstanding DD's Realised this month</td> <td>{brsReconciliationData?.outpaymentamount}</td> <td></td> </tr>
                                                <tr style={{ textAlign: 'left' }}> <td></td> <td style={{ textAlign: 'center' }}> <b>Total</b> </td> <td> <b> {( Number(brsReconciliationData?.paymentamount || 0) + Number(brsReconciliationData?.directcredit || 0) + Number(brsReconciliationData?.outpaymentamount || 0) ).toFixed(2)} </b> </td> <td></td> </tr>
                                                {/* Total After ADD */}
                                                <tr style={{ textAlign: 'left' }}> <td></td> <td style={{ textAlign: 'center' }}> <b>Total</b> </td> <td></td> <td> <b> {( Number(brsReconciliationData?.balance || 0) + Number(brsReconciliationData?.paymentamount || 0) + Number(brsReconciliationData?.directcredit || 0) + Number(brsReconciliationData?.outpaymentamount || 0) ).toFixed(2)} </b> </td> </tr>
                                                {/* LESS Section */}
                                                <tr> <td></td> <td colSpan={3} style={{ textAlign: 'left' }}> <b>LESS</b> </td> </tr>
                                                <tr style={{ textAlign: 'left' }}> <td></td> <td>(a) Direct Debit</td> <td>{brsReconciliationData?.directdebit}</td> <td></td> </tr>
                                                <tr style={{ textAlign: 'left' }}> <td></td> <td>(b) DD's/Receipts Deposit But Not Realised</td> <td>{brsReconciliationData?.receiptamount}</td> <td></td> </tr>
                                                <tr style={{ textAlign: 'left' }}> <td></td> <td>(c) Outstanding Cheque Realised in this month</td> <td>{brsReconciliationData?.outreceiptamount}</td> <td></td> </tr>
                                                <tr style={{ textAlign: 'left' }}> <td></td> <td style={{ textAlign: 'center' }}> <b>Total</b> </td> <td> <b> {( Number(brsReconciliationData?.directdebit || 0) + Number(brsReconciliationData?.receiptamount || 0) + Number(brsReconciliationData?.outreceiptamount || 0) ).toFixed(2)} </b> </td> <td></td> </tr>
                                                {/* Total After LESS */}
                                                <tr style={{ textAlign: 'left' }}> <td></td> <td style={{ textAlign: 'center' }}> <b>Total</b> </td> <td></td> <td> <b> {( Number(brsReconciliationData?.balance || 0) + Number(brsReconciliationData?.directdebit || 0) + Number(brsReconciliationData?.receiptamount || 0) + Number(brsReconciliationData?.outreceiptamount || 0) ).toFixed(2)} </b> </td> </tr>
                                                {/* Final Balance */}
                                                <tr style={{ textAlign: 'left' }}> <td></td> <td style={{ textAlign: 'center' }}> <b>Balance as per Bank Book</b> </td> <td></td> <td> <b> {( Number(brsReconciliationData?.balance || 0) + Number(brsReconciliationData?.paymentamount || 0) + Number(brsReconciliationData?.directcredit || 0) + Number(brsReconciliationData?.outpaymentamount || 0) - (Number(brsReconciliationData?.directdebit || 0) + Number(brsReconciliationData?.receiptamount || 0) + Number(brsReconciliationData?.outreceiptamount || 0)) ).toFixed(2)} </b> </td> </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div style={{ marginBottom: '10px' }}> <button className='btn btn-danger btn-sm' type='button' onClick={handlePrint} > PRINT <MdOutlinePictureAsPdf /> </button> </div>
                                </div>
                            )}

                        </Form>
                    </FormikProvider>
                </OFMSUI.Container >
            </div>

        </>
    )
}

export default BankRenconciliationStatement
